import {required} from "vuelidate/lib/validators";  
const activities = {
    data() { 
      return {   
        activitiesData: { 
          Title: "", 
          Description: "", 
          SeoTitle: "", 
          SeoKeyword: "", 
          SeoDescription: "", 
          Imagegallery: "", 
          Startdate:"",
          Enddate:"",
          Websiteid: "", 
          Deleted: false, 
          }, 
  
          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('news.AddEdit.Title')},  
            Description:{FieldName:"Description",Field:"input",FieldTitle:this.$t('news.AddEdit.Description')},  
            SeoTitle:{FieldName:"SeoTitle",Field:"input",FieldTitle:this.$t('news.AddEdit.SeoTitle')}, 
            SeoKeyword:{FieldName:"SeoKeyword",Field:"input",FieldTitle:this.$t('news.AddEdit.SeoKeyword')}, 
            SeoDescription:{FieldName:"SeoDescription",Field:"input",FieldTitle:this.$t('news.AddEdit.SeoDescription')}, 
            Imagegallery:{FieldName:"Imagegallery",Field:"input",FieldTitle:this.$t('news.AddEdit.Imagegallery')}, 
            Startdate:{FieldName:"Startdate",Field:"input",FieldTitle:this.$t('news.AddEdit.Startdate'),FieldType:"text"},
            Enddate:{FieldName:"Enddate",Field:"input",FieldTitle:this.$t('news.AddEdit.Enddate'),FieldType:"text"},
            Websiteid:{FieldName:"Websiteid",Field:"input"},           

          } ,
          duyuru_tipleri: [
            { Id:"1",  Value:"Normal Duyuru" },
            { Id:"2",  Value:"Yeni" },
            { Id:"3",  Value:"Önemli" },
          ]
      }
    },  
    validations:{ 
      FormData: {  
        Title: {required},   
        Description: {required},  
        SeoTitle: {},  
        SeoKeyword: {},   
        SeoDescription: {},  
        Startdate: {required},   
        Enddate: {required}, 
        Imagegallery: {},  
        Websiteid: {required},   
  
      }
 
  },
  created(){

            for (var i = 0; i < this.duyuru_tipleri.length; i++) {
              this.FormDataType.Newstype.ComboDataArray.push({
                Id: this.duyuru_tipleri[i].Id,
                Value: this.duyuru_tipleri[i].Value,
              });
            }         

  }
}
export default activities